// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AboutUsBlock_root__MNVw2 {
  padding: 40px 0;
}
.AboutUsBlock_root__MNVw2 .AboutUsBlock_aboutUsBlock__hK61- {
  min-height: calc(100vh - 134px);
  padding: 40px 0;
}
.AboutUsBlock_root__MNVw2 .AboutUsBlock_aboutUsBlock__hK61- .AboutUsBlock_card__y31GP {
  width: 35rem;
  color: #00377c;
}
.AboutUsBlock_root__MNVw2 .AboutUsBlock_aboutUsBlock__hK61- .AboutUsBlock_card__y31GP .AboutUsBlock_cardBody__WjFjG .AboutUsBlock_titleBlock__nUgqM {
  font-size: 26px;
  font-weight: bold;
}
.AboutUsBlock_root__MNVw2 .AboutUsBlock_aboutUsBlock__hK61- .AboutUsBlock_card__y31GP .AboutUsBlock_cardBody__WjFjG .AboutUsBlock_brandsBlock__9s6J6 .AboutUsBlock_titleBlock__nUgqM {
  font-size: 16px;
  color: #d71921;
}

@media (max-width: 768px) {
  .AboutUsBlock_root__MNVw2 {
    padding: 20px 0;
  }
  .AboutUsBlock_root__MNVw2 .AboutUsBlock_aboutUsBlock__hK61- {
    min-height: calc(100vh - 85px);
    padding: 20px 0;
  }
  .AboutUsBlock_root__MNVw2 .AboutUsBlock_aboutUsBlock__hK61- .AboutUsBlock_card__y31GP {
    font-size: 14px;
  }
  .AboutUsBlock_root__MNVw2 .AboutUsBlock_aboutUsBlock__hK61- .AboutUsBlock_card__y31GP .AboutUsBlock_cardBody__WjFjG .AboutUsBlock_titleBlock__nUgqM {
    font-size: 18px;
  }
  .AboutUsBlock_root__MNVw2 .AboutUsBlock_aboutUsBlock__hK61- .AboutUsBlock_card__y31GP .AboutUsBlock_cardBody__WjFjG .AboutUsBlock_brandsBlock__9s6J6 .AboutUsBlock_titleBlock__nUgqM {
    font-size: 14px;
  }
  .AboutUsBlock_root__MNVw2 .AboutUsBlock_aboutUsBlock__hK61- .AboutUsBlock_card__y31GP .AboutUsBlock_cardBody__WjFjG .AboutUsBlock_imgBlock__gymVM div img {
    width: 65px;
  }
}
@media (max-width: 500px) {
  .AboutUsBlock_root__MNVw2 .AboutUsBlock_aboutUsBlock__hK61- {
    min-height: calc(100vh - 81px);
  }
  .AboutUsBlock_root__MNVw2 .AboutUsBlock_aboutUsBlock__hK61- .AboutUsBlock_card__y31GP {
    font-size: 12px;
  }
  .AboutUsBlock_root__MNVw2 .AboutUsBlock_aboutUsBlock__hK61- .AboutUsBlock_card__y31GP .AboutUsBlock_cardBody__WjFjG .AboutUsBlock_titleBlock__nUgqM {
    font-size: 16px;
  }
  .AboutUsBlock_root__MNVw2 .AboutUsBlock_aboutUsBlock__hK61- .AboutUsBlock_card__y31GP .AboutUsBlock_cardBody__WjFjG .AboutUsBlock_brandsBlock__9s6J6 .AboutUsBlock_titleBlock__nUgqM {
    font-size: 12px;
  }
  .AboutUsBlock_root__MNVw2 .AboutUsBlock_aboutUsBlock__hK61- .AboutUsBlock_card__y31GP .AboutUsBlock_cardBody__WjFjG .AboutUsBlock_imgBlock__gymVM div img {
    width: 50px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Header/AboutUsMenu/AboutUsBlock/AboutUsBlock.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;AACE;EACE,+BAAA;EACA,eAAA;AACJ;AACI;EACE,YAAA;EACA,cAAA;AACN;AAEQ;EACE,eAAA;EACA,iBAAA;AAAV;AAIU;EACE,eAAA;EACA,cAAA;AAFZ;;AAUA;EACE;IACE,eAAA;EAPF;EASE;IACE,8BAAA;IACA,eAAA;EAPJ;EASI;IACE,eAAA;EAPN;EAUQ;IACE,eAAA;EARV;EAYU;IACE,eAAA;EAVZ;EAgBY;IACE,WAAA;EAdd;AACF;AAuBA;EAEI;IACE,8BAAA;EAtBJ;EAwBI;IACE,eAAA;EAtBN;EAyBQ;IACE,eAAA;EAvBV;EA2BU;IACE,eAAA;EAzBZ;EA+BY;IACE,WAAA;EA7Bd;AACF","sourcesContent":[".root {\n  padding: 40px 0;\n\n  .aboutUsBlock {\n    min-height: calc(100vh - 134px);\n    padding: 40px 0;\n\n    .card {\n      width: 35rem;\n      color: #00377c;\n\n      .cardBody {\n        .titleBlock {\n          font-size: 26px;\n          font-weight: bold;\n        }\n\n        .brandsBlock {\n          .titleBlock {\n            font-size: 16px;\n            color: #d71921;\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .root {\n    padding: 20px 0;\n\n    .aboutUsBlock {\n      min-height: calc(100vh - 85px);\n      padding: 20px 0;\n\n      .card {\n        font-size: 14px;\n\n        .cardBody {\n          .titleBlock {\n            font-size: 18px;\n          }\n\n          .brandsBlock {\n            .titleBlock {\n              font-size: 14px;\n            }\n          }\n\n          .imgBlock {\n            div {\n              img {\n                width: 65px;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 500px) {\n  .root {\n    .aboutUsBlock {\n      min-height: calc(100vh - 81px);\n\n      .card {\n        font-size: 12px;\n\n        .cardBody {\n          .titleBlock {\n            font-size: 16px;\n          }\n\n          .brandsBlock {\n            .titleBlock {\n              font-size: 12px;\n            }\n          }\n\n          .imgBlock {\n            div {\n              img {\n                width: 50px;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `AboutUsBlock_root__MNVw2`,
	"aboutUsBlock": `AboutUsBlock_aboutUsBlock__hK61-`,
	"card": `AboutUsBlock_card__y31GP`,
	"cardBody": `AboutUsBlock_cardBody__WjFjG`,
	"titleBlock": `AboutUsBlock_titleBlock__nUgqM`,
	"brandsBlock": `AboutUsBlock_brandsBlock__9s6J6`,
	"imgBlock": `AboutUsBlock_imgBlock__gymVM`
};
export default ___CSS_LOADER_EXPORT___;
